import React, { useState, useEffect } from 'react';
import { settingsService } from '../../services/settingsService';

function Pengurus() {
  const [pengurus, setPengurus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [jabatanList, setJabatanList] = useState([]);
  const [form, setForm] = useState({
    id: null,
    jabatan: 'Ketua',
    namaLengkap: '',
    nik: '',
    noHP: '',
    alamat: '',
    masaJabatanMulai: '',
    masaJabatanSelesai: ''
  });

  useEffect(() => {
    fetchPengurus();
    fetchJabatanEnum();
  }, []);

  const fetchPengurus = async () => {
    try {
      setLoading(true);
      const res = await settingsService.getPengurus();
      let data = res.data.data;
      if (data && !Array.isArray(data) && Array.isArray(data.data)) {
        data = data.data;
      }
      setPengurus(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching pengurus:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchJabatanEnum = async () => {
    try {
      const res = await settingsService.getJabatanEnum();
      // API returns: res.data.data = { data: ["val1", "val2", ...] }
      // Extract the inner array
      const innerData = res.data?.data?.data || res.data?.data;
      if (innerData && Array.isArray(innerData) && innerData.length > 0) {
        setJabatanList(innerData);
      }
    } catch (error) {
      console.error('Error fetching jabatan enum:', error);
    }
  };

  const savePengurus = async () => {
    if (!form.namaLengkap) {
      alert('Nama lengkap wajib diisi');
      return;
    }
    setSaving(true);
    try {
      if (form.id) {
        await settingsService.updatePengurus(form.id, form);
      } else {
        await settingsService.createPengurus(form);
      }
      setShowForm(false);
      resetForm();
      fetchPengurus();
      alert('Pengurus berhasil disimpan');
    } catch (error) {
      alert(error.response?.data?.message || 'Gagal menyimpan pengurus');
    } finally {
      setSaving(false);
    }
  };

  const deletePengurus = async (id) => {
    if (!confirm('Yakin ingin menghapus pengurus ini?')) return;
    try {
      await settingsService.deletePengurus(id);
      fetchPengurus();
      alert('Pengurus berhasil dihapus');
    } catch (error) {
      alert('Gagal menghapus pengurus');
    }
  };

  const editPengurus = (p) => {
    setForm({
      id: p.Id,
      jabatan: p.Jabatan,
      namaLengkap: p.NamaLengkap,
      nik: p.NIK || '',
      noHP: p.NoHP || '',
      alamat: p.Alamat || '',
      masaJabatanMulai: p.MasaJabatanMulai ? p.MasaJabatanMulai.split('T')[0] : '',
      masaJabatanSelesai: p.MasaJabatanSelesai ? p.MasaJabatanSelesai.split('T')[0] : ''
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setForm({
      id: null,
      jabatan: 'Ketua',
      namaLengkap: '',
      nik: '',
      noHP: '',
      alamat: '',
      masaJabatanMulai: '',
      masaJabatanSelesai: ''
    });
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title"><i className="fas fa-users mr-2"></i>Pengurus Cooperativa</h3>
        <button className="btn btn-primary btn-sm" onClick={() => { resetForm(); setShowForm(true); }}>
          <i className="fas fa-plus mr-1"></i> Tambah Pengurus
        </button>
      </div>
      <div className="card-body">
        {loading ? (
          <div className="text-center py-3"><i className="fas fa-spinner fa-spin mr-2"></i>Memuat...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="thead-light">
                <tr>
                  <th>Jabatan</th>
                  <th>Nama Lengkap</th>
                  <th>NIK</th>
                  <th>No. HP</th>
                  <th>Alamat</th>
                  <th>Masa Jabatan</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(pengurus) && pengurus.length > 0 ? (
                  pengurus.map(p => (
                    <tr key={p.Id}>
                      <td><span className="badge badge-info">{p.Jabatan}</span></td>
                      <td>{p.NamaLengkap}</td>
                      <td>{p.NIK || '-'}</td>
                      <td>{p.NoHP || '-'}</td>
                      <td>{p.Alamat || '-'}</td>
                      <td>
                        {p.MasaJabatanMulai ? new Date(p.MasaJabatanMulai).getFullYear() : '-'}
                        {p.MasaJabatanSelesai ? ` - ${new Date(p.MasaJabatanSelesai).getFullYear()}` : ''}
                      </td>
                      <td>
                        <button className="btn btn-warning btn-xs mr-1" onClick={() => editPengurus(p)}>
                          <i className="fas fa-edit"></i>
                        </button>
                        <button className="btn btn-danger btn-xs" onClick={() => deletePengurus(p.Id)}>
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">Belum ada data pengurus</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {showForm && (
          <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{form.id ? 'Edit' : 'Tambah'} Pengurus</h5>
                  <button type="button" className="close" onClick={() => setShowForm(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Jabatan *</label>
                        <select className="form-control" value={form.jabatan} onChange={e => setForm({...form, jabatan: e.target.value})}>
                          {jabatanList.map((jab, idx) => (
                            <option key={idx} value={jab}>{jab}</option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Nama Lengkap *</label>
                        <input type="text" className="form-control" value={form.namaLengkap} onChange={e => setForm({...form, namaLengkap: e.target.value})} />
                      </div>
                      <div className="form-group">
                        <label>NIK</label>
                        <input type="text" className="form-control" value={form.nik} onChange={e => setForm({...form, nik: e.target.value})} />
                      </div>
                      <div className="form-group">
                        <label>No. HP</label>
                        <input type="text" className="form-control" value={form.noHP} onChange={e => setForm({...form, noHP: e.target.value})} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Alamat</label>
                        <textarea className="form-control" rows="3" value={form.alamat} onChange={e => setForm({...form, alamat: e.target.value})}></textarea>
                      </div>
                      <div className="form-group">
                        <label>Masa Jabatan Mulai</label>
                        <input type="date" className="form-control" value={form.masaJabatanMulai} onChange={e => setForm({...form, masaJabatanMulai: e.target.value})} />
                      </div>
                      <div className="form-group">
                        <label>Masa Jabatan Selesai</label>
                        <input type="date" className="form-control" value={form.masaJabatanSelesai} onChange={e => setForm({...form, masaJabatanSelesai: e.target.value})} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Batal</button>
                  <button type="button" className="btn btn-primary" onClick={savePengurus} disabled={saving}>
                    {saving ? 'Menyimpan...' : 'Simpan'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Pengurus;